import React from 'react';
import { Link } from 'react-router-dom';

export default function NotFound() {
  return (
    <section style={{
      minHeight: '70vh', display: 'flex', flexDirection: 'column',
      alignItems: 'center', justifyContent: 'center', textAlign: 'center',
      padding: '120px 24px', background: 'var(--cream)'
    }}>
      <p style={{ fontSize: 14, letterSpacing: 3, textTransform: 'uppercase', color: 'var(--gold)' }}>404</p>
      <h1 style={{
        fontFamily: "'Cormorant Garamond', serif", fontSize: 64,
        fontWeight: 400, color: 'var(--forest)', margin: '16px 0'
      }}>
        Page <em style={{ color: 'var(--gold)' }}>Not Found</em>
      </h1>
      <p style={{ color: 'var(--text-mid)', maxWidth: 480, lineHeight: 1.8 }}>
        The page you're looking for seems to have wandered off the path.
      </p>
      <Link to="/" className="btn-primary" style={{ marginTop: 32 }}>
        Back to Home
      </Link>
    </section>
  );
}
